import {
  deviceImg,
  deviceState,
  imgData,
  orderOperate,
  pestOrderOperate,
  sporeOrderOperate, spRealDataTime, spUserDevice, userLogin,
  xcUserLogin
} from "../until/api/SporePest";

/**
 * 祥辰登录获取token
 */
export default {
  getXCToken(param, callback) {
    xcUserLogin(param).then(response => {
      callback(response.data.data.token);
    }).catch(error => {
      console.log("error", error);
    })
  },

  /**
   * 获取设备状态
   * @param deviceAddr
   * @param callback
   */
  getDeviceState(deviceAddr, callback) {
    deviceState(deviceAddr).then(response => {
      callback(response.data.data);
    }).catch(error => {
      console.log("error", error);
    })
  },

  /**
   * 设置设备接口命令
   * @param param
   * @param callback
   */
  setOrder(param, callback) {
    orderOperate(param).then(response => {
      callback(response);
    }).catch(error => {
      console.log("error", error)
    })
  },

  /**
   * 获取设备图片
   * @param deviceAddr
   * @param startTime
   * @param endTime
   * @param callback
   */
  getDeviceImg(deviceAddr, startTime, endTime, callback) {
    deviceImg(deviceAddr, startTime, endTime).then(response => {
      callback(response.data.data);
    }).catch(error => {
      console.log("error", error);
    })
  },

  /**
   * 根据图片获取分析结果
   * @param imgId
   * @param callback
   */
  getImgData(imgId, callback) {
    imgData(imgId).then(response => {
      callback(response.data.data);
    }).catch(error=> {
      console.log("error", error)
    })
  },

  /**
   * 设置虫情接口命令
   * @param param
   * @param callback
   */
  setPestOrder(param, callback) {
    pestOrderOperate(param).then(response => {
      callback(response);
    }).catch(error => {
      console.log("error", error)
    })
  },

  /**
   * 设置孢子接口命令
   * @param param
   * @param callBack
   */
  setSporeOrder(param, callBack) {
    sporeOrderOperate(param).then(response => {
      callBack(response);
    }).catch(error => {
      console.log("error", error)
    })
  },

  getSpToken(param, callback) {
    userLogin(param).then(response => {
      callback(response.data.data.token);
    }).catch(error => {
      console.log("error", error);
    })
  },

  getSpDeviceList(callback) {
    spUserDevice().then(response => {
      callback(response.data);
    }).catch(error => {
      console.log("error", error)
    })
  },

  spRealDataTime(deviceAddr, callBack) {
    spRealDataTime(deviceAddr).then(response => {
      callBack(response.data);
    }).catch(error => {
      console.log("error", error);
    })
  }
}



// WEBPACK FOOTER //
// ./src/tool/SporePestCommon.js